import { Accordion } from '@zoopla-eng/zds-components/accordion';
import { useState } from 'react';
import { NewHomesPageSubtitleShort } from '../NewHomesPageSubtitleShort';
import { NewHomesFaqContent } from './newHomesFaqContent';

type NewHomeFaqProps = { newHomesFaqContent: NewHomesFaqContent };

export const NewHomesFaq: React.FC<NewHomeFaqProps> = ({
    newHomesFaqContent
}) => {
    const [value, updateValue] = useState<string[]>([]);

    return (
        <>
            <NewHomesPageSubtitleShort>
                We answer your questions about new-build homes
            </NewHomesPageSubtitleShort>
            <Accordion
                value={value}
                panels={newHomesFaqContent}
                onValueChange={updateValue}
                maxWidth="100%"
            />
        </>
    );
};
